/* Tidies Shopify's policy markup (/policies/*) so it reads like the theme's
   own pages. The policies are written in the admin editor, where section
   headings are often a bold line + <br> rather than real headings, so:
   - a paragraph that starts with a bold line followed by <br> (or is only a
     bold line) becomes an <h2> + the rest of the paragraph;
   - an in-text title at the top (directly followed by "Ultimo aggiornamento")
     replaces the page title, since it's the name the owner gave the policy;
   - "Ultimo aggiornamento: …" moves under the title. */
(function () {
  var title = document.querySelector('.shopify-policy__title h1');
  var rte = document.querySelector('.shopify-policy__body .rte');
  if (!title || !rte) return;

  function isBlank(n) { return n.nodeType === 3 && !n.textContent.trim(); }
  function firstReal(p) { var n = p.firstChild; while (n && isBlank(n)) n = n.nextSibling; return n; }
  function nextReal(n) { n = n.nextSibling; while (n && isBlank(n)) n = n.nextSibling; return n; }

  // Bold-line headings → <h2>
  Array.prototype.slice.call(rte.querySelectorAll('p')).forEach(function (p) {
    var first = firstReal(p);
    if (!first || first.nodeName !== 'STRONG') return;
    var after = nextReal(first);
    if (after && after.nodeName !== 'BR') return;          // bold words inside a sentence
    var h = document.createElement('h2');
    h.textContent = first.textContent.trim();
    p.parentNode.insertBefore(h, p);
    p.removeChild(first);
    if (after) p.removeChild(after);
    if (!p.textContent.trim() && !p.querySelector('img, a')) p.parentNode.removeChild(p);
  });

  var DATE = /^\s*ultimo aggiornamento/i;

  // In-text title at the very top → page title. Only a real document title:
  // a heading directly followed by the "Ultimo aggiornamento" line.
  var top = rte.firstElementChild;
  var afterTop = top && top.nextElementSibling;
  if (top && /^H[1-4]$/.test(top.nodeName) && afterTop && DATE.test(afterTop.textContent)) {
    title.textContent = top.textContent.trim();
    rte.removeChild(top);
  }

  // "Ultimo aggiornamento" line → under the title
  var updated = null;
  Array.prototype.slice.call(rte.querySelectorAll('p, em')).some(function (el) {
    if (DATE.test(el.textContent)) { updated = el; return true; }
    return false;
  });
  if (updated) {
    var text = updated.textContent.trim();
    var holder = updated.closest('p') || updated;
    if (holder.textContent.trim() === text) holder.parentNode.removeChild(holder);
    else updated.parentNode.removeChild(updated);
    var u = document.createElement('p');
    u.className = 'pg__updated';
    u.textContent = text;
    title.insertAdjacentElement('afterend', u);
  }
}());
